import React from 'react';

import {
  Highlight as RsuiteHighlight,
  type HighlightProps as RsuiteHighlightProps,
} from 'rsuite';
import styled from 'styled-components';

const StyledHighlight: React.FC<RsuiteHighlightProps> = styled(RsuiteHighlight)`
  .rs-highlight-mark {
    border-radius: 4px;
    background-color: rgb(255, 241, 170);
    padding: 0;
  }
`;

export const Highlight: React.FC<RsuiteHighlightProps> = ({
  children,
  ...props
}) => {
  return (
    <StyledHighlight
      {...props}
      renderMark={(match, index) => (
        <mark
          key={index}
          className="rs-highlight-mark"
          data-testid="highlight-mark"
        >
          {match}
        </mark>
      )}
    >
      {children}
    </StyledHighlight>
  );
};
